<template>
  <rich-text-editor :value="value" @input="onInput" @blur="$emit('save')" />
</template>
<script>
import RichTextEditor from '@/components/generic/rich-text-editor'

export default {
  components: { RichTextEditor },
  props: {
    id: String,
    value: String
  },
  methods: {
    onInput(value) {
      const container = document.createElement('div')
      container.innerHTML = value
      const isEmpty = container.innerText.trim() == ''

      if (isEmpty) {
        this.$emit('input', null)
      } else {
        this.$emit('input', value)
      }
    }
  }
}
</script>